import React, { useState, useEffect, useRef } from 'react'
import { FormattedMessage } from 'react-intl'
import CircularProgress from '@material-ui/core/CircularProgress'
import Button from '@material-ui/core/Button'
import Icon from '@material-ui/core/Icon'
import { useIntl } from 'react-intl'
import classnames from 'classnames'

import { DeviceContext } from '../contexts/deviceContext'
import { RouterContext } from '../contexts/routerContext'
import { ErrorContext } from '../contexts/errorContext'

import Footer from '../fronted-share-components/src/Footer'
import NotSupport from '../fronted-share-components/src/NotSupport'
import { version, buildNumber } from '../constants/buildNumber.json'
import { AMPLITUDE_LOCALSTORAGE_KEY } from '../constants'

import '../styles/login.scss'

import logoImage from '../images/landing-page/logo.svg'
import logoImage2 from '../images/landing-page/logo2.svg'
import howItWorkImage1 from '../images/landing-page/img1.svg'
import howItWorkImage2 from '../images/landing-page/img2.svg'
import howItWorkImage3 from '../images/landing-page/img3.svg'
import howItWorkImage4 from '../images/landing-page/img4.svg'
import howItWorkImage5 from '../images/landing-page/img5.svg'
import howItWorkImage6 from '../images/landing-page/img6.svg'
import { detectBrowserSupport } from '../util/utilitys.js'

import SignIn from '../fronted-share-components/src/signIn/SignIn'
import SignInBtn from '../fronted-share-components/src/signIn/components/SignInBtn'
import { Dialog } from '@material-ui/core'
import LocalStorageManager from '../util/localStorageManager'
import AmplitudeEventManager from '../fronted-share-components/src/utils/amplitudeEventManager'

function WrapSignIn(props) {
    const intl = useIntl()

    const deviceContext = React.useContext(DeviceContext)
    const errorContext = React.useContext(ErrorContext)
    const [isLoginFinish, setIsLoginFinish] = useState(false)
    const [isSignInOpen, setSignInOpen] = useState(false)
    const [isScrollButtonShown, setScrollButtonShown] = useState(false)
    const { setPath } = React.useContext(RouterContext)
    const [howItWorksRef, setHowItWorksRef] = useState(null)
    const scrollContainerRef = React.useRef()

    let browserSupport = detectBrowserSupport()
    let notSupportDescription = ''
    if (browserSupport === 'wrongBrowser') {
        notSupportDescription = intl.formatMessage({
            id: 'ldpage_camera_browser_not_supported_desc',
        })
    } else if (browserSupport === 'updateBrowser') {
        notSupportDescription = intl.formatMessage({
            id: 'ldpage_camera_update_browser_desc',
        })
    }

    const mounted = useRef(false)
    useEffect(() => {
        mounted.current = true
        window.addEventListener('resize', onResize)
        return () => {
            mounted.current = false
            window.removeEventListener('resize', onResize)
        }
    })

    useEffect(() => {
        if (howItWorksRef && scrollContainerRef.current) {
            const top = howItWorksRef.offsetTop
            const scrollTop = scrollContainerRef.current.scrollTop
            setScrollButtonShown(top >= window.innerHeight && scrollTop <= 64)
        }
    }, [howItWorksRef, scrollContainerRef])

    useEffect(() => {
        const locastorageManager = LocalStorageManager.getInstance()
        const alreadySignIn = locastorageManager.getAmplitudeEventRecord(
            AMPLITUDE_LOCALSTORAGE_KEY.ALREADY_SIGN_IN
        )
        if (!alreadySignIn) {
            AmplitudeEventManager.signInPageLanded(`${version}.${buildNumber}`)
            locastorageManager.setAmplitudeEventRecord({
                alfredAlreadySignIn: true,
            })
        }
    }, [])

    function onResize() {
        if (howItWorksRef && scrollContainerRef.current) {
            const top = howItWorksRef.offsetTop
            const scrollTop = scrollContainerRef.current.scrollTop
            setScrollButtonShown(top >= window.innerHeight && scrollTop <= 64)
        }
    }

    function retryPasswordTooManyTimesAction() {
        window.logManager.error('retryPasswordTooManyTimes')
        errorContext.pushErrorMessage({
            errorKey: 'retryPasswordTooManyTimes',
        })
    }
    function apiErrorAction() {
        errorContext.pushErrorMessage({
            errorKey: 'APIServerError',
        })
    }
    function networkErrorAction() {
        errorContext.pushErrorMessage({
            errorKey: 'NetworkErrorSignIn',
        })
    }
    function unVerifiedError() {
        errorContext.pushErrorMessage({
            errorKey: 'unVerifiedError',
        })
    }

    async function onSignInSuccess({
        idToken,
        accountMail,
        name,
        image,
        firebaseUid,
    }) {
        setIsLoginFinish(false)

        window.eventManager.signInComplete({
            signin_completed_google: new Date(),
        })
        window.eventManager.setCountdownLoginExperience()

        const loginResult = await deviceContext.mutations.onSignInSuccess({
            idToken,
            profileObj: {
                name: name,
                email: accountMail,
                imageUrl: image,
            },
            firebaseUid,
        })
        if (loginResult === true) {
            // route to camera
            setPath('camera')
        }
        mounted.current && setIsLoginFinish(true)
    }

    function onNotSignIn() {
        deviceContext.mutations.signOut()
        setIsLoginFinish(true)
    }

    const SignInDialog = ({
        signInWithGoogle,
        signInWithApple,
        goSignInWithEmailPage,
    }) => {
        return (
            <Dialog
                className="sign-in-modal"
                maxWidth="xs"
                onClose={() => setSignInOpen(false)}
                open={isSignInOpen}
            >
                <div className="close" onClick={() => setSignInOpen(false)}>
                    <Icon>close</Icon>
                </div>
                <div className="body">
                    <div className="title">
                        <FormattedMessage id="sign_in" />
                    </div>
                    <div className="content">
                        <FormattedMessage id="sign_in_hint" />
                    </div>
                    <div className="button" onClick={signInWithGoogle}>
                        <SignInBtn type="google" />
                    </div>
                    <div className="button" onClick={goSignInWithEmailPage}>
                        <SignInBtn type="email" />
                    </div>
                    <div className="button" onClick={signInWithApple}>
                        <SignInBtn type="apple" />
                    </div>
                    <div className="tos">
                        <FormattedMessage
                            id="sign_in_tos"
                            values={{
                                termsOfService: (
                                    <a
                                        href="https://alfredcamera.zendesk.com/hc/en-us/articles/360034151472-Terms-of-Service?utm_source=webcamera&utm_medium=referral&utm_campaign=signin_dialog_tos"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FormattedMessage id="TermsofService" />
                                    </a>
                                ),
                                privatePolicy: (
                                    <a
                                        href="https://alfredcamera.zendesk.com/hc/en-us/articles/360034522931-Privacy-Policy?utm_source=webcamera&utm_medium=referral&utm_campaign=signin_dialog_privacy"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <FormattedMessage id="PrivatePolicy" />
                                    </a>
                                ),
                            }}
                        />
                    </div>
                </div>
            </Dialog>
        )
    }

    let component = null
    if (browserSupport !== true) {
        component = (
            <>
                <div className="main-header fixed">
                    <img width={324} height={40} src={logoImage2} />
                </div>
                <NotSupport
                    title="ldpage_not_supported_title"
                    description={notSupportDescription}
                    style={{ height: 'calc(100vh - 112px)' }}
                />
            </>
        )
    } else {
        component = (
            <SignIn
                isLoginFinish={isLoginFinish}
                role="camera"
                productVersion={`WebCamera ${version}`}
                onSignInSuccess={onSignInSuccess}
                retryPasswordTooManyTimes={retryPasswordTooManyTimesAction}
                networkError={networkErrorAction}
                apiError={apiErrorAction}
                unVerifiedError={unVerifiedError}
                onNotSignIn={onNotSignIn}
                onEmailSignIn={() => {}}
                backToSignIn={true}
            >
                <SignInDialog />
                <div className="landing-section home">
                    <div className="main-header">
                        <img width={335} height={40} src={logoImage} />
                        <Button
                            variant="outlined"
                            className="sign-in"
                            onClick={() => setSignInOpen(true)}
                        >
                            <FormattedMessage id="sign_in" />
                        </Button>
                    </div>
                    <div className="bg" />
                    <div className="main">
                        <h1 className="title">
                            <FormattedMessage id="ldpage_camera_heading_title" />
                        </h1>
                        <div className="content">
                            <FormattedMessage id="ldpage_camera_heading_text" />
                        </div>
                        <div className="button">
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => setSignInOpen(true)}
                            >
                                <FormattedMessage id="get_started" />
                            </Button>
                        </div>
                    </div>
                    {isScrollButtonShown && (
                        <div className="button-container">
                            <span
                                className="button"
                                onClick={() => {
                                    const top = howItWorksRef.offsetTop
                                    scrollContainerRef.current.scrollTo({
                                        top,
                                        behavior: 'smooth',
                                    })
                                }}
                            >
                                <FormattedMessage id="see_how_it_works" />
                                <Icon className="icon">expand_more</Icon>
                            </span>
                        </div>
                    )}
                </div>
                <div
                    className="landing-section how-it-works"
                    ref={setHowItWorksRef}
                >
                    <h2 className="title">
                        <FormattedMessage id="how_it_works" />
                    </h2>
                    <div className="content">
                        <div className="item">
                            <div className="image">
                                <img src={howItWorkImage1} />
                            </div>
                            <div className="title">
                                <FormattedMessage id="how_it_works_title_1" />
                            </div>
                            <div className="content">
                                <FormattedMessage id="how_it_works_text_1" />
                            </div>
                        </div>
                        <div className="item">
                            <div className="image">
                                <img src={howItWorkImage2} />
                            </div>
                            <div className="title">
                                <FormattedMessage id="how_it_works_title_2" />
                            </div>
                            <div className="content">
                                <FormattedMessage id="how_it_works_text_2" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="landing-section reasons">
                    <h2 className="title">
                        <FormattedMessage id="reasons_to_choose" />
                    </h2>
                    <div className="content">
                        <div className="item">
                            <div className="image">
                                <img src={howItWorkImage4} />
                            </div>
                            <div className="title">
                                <FormattedMessage id="reasons_to_choose_title_1" />
                            </div>
                            <div className="content">
                                <FormattedMessage id="reasons_to_choose_text_1" />
                            </div>
                        </div>
                        <div className="item">
                            <div className="image">
                                <img src={howItWorkImage5} />
                            </div>
                            <div className="title">
                                <FormattedMessage id="reasons_to_choose_title_2" />
                            </div>
                            <div className="content">
                                <FormattedMessage id="reasons_to_choose_text_2" />
                            </div>
                        </div>
                        <div className="item">
                            <div className="image">
                                <img src={howItWorkImage6} />
                            </div>
                            <div className="title">
                                <FormattedMessage id="reasons_to_choose_title_3" />
                            </div>
                            <div className="content">
                                <FormattedMessage id="reasons_to_choose_text_3" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="landing-section try">
                    <h2 className="title">
                        <FormattedMessage id="try_in_browser" />
                    </h2>
                    <div className="subtitle">
                        <FormattedMessage id="peace_of_mind" />
                    </div>
                    <div>
                        <Button
                            variant="contained"
                            color="primary"
                            className="button"
                            onClick={() => setSignInOpen(true)}
                        >
                            <FormattedMessage id="get_started" />
                        </Button>
                    </div>
                </div>
            </SignIn>
        )
    }

    return (
        <div
            className={classnames('login-container', {
                'not-supported': browserSupport !== true,
            })}
        >
            {browserSupport === true && (
                <div
                    className={
                        isLoginFinish === false
                            ? 'loading-section_show'
                            : 'loading-section'
                    }
                >
                    <CircularProgress
                        size={60}
                        color="secondary"
                        id="signInLoading"
                    />
                </div>
            )}
            <div
                className="scroll-container"
                ref={scrollContainerRef}
                onScroll={onResize}
            >
                {component}
                <Footer
                    detectIsSignInPage={() => true}
                    terms="https://alfredcamera.zendesk.com/hc/en-us/articles/360034151472-Terms-of-Service?utm_source=webcamera&utm_medium=referral&utm_campaign=landingpage_footer_tos"
                    privacy="https://alfredcamera.zendesk.com/hc/en-us/articles/360034522931-Privacy-Policy?utm_source=webcamera&utm_medium=referral&utm_campaign=landingpage_footer_privacy"
                    FAQ="https://alfredcamera.zendesk.com/hc/en-us?utm_source=webcamera&utm_medium=referral&utm_campaign=landingpage_footer_faq"
                />
            </div>
        </div>
    )
}

export default React.memo(WrapSignIn)
